import { message } from "antd";
import {
  downloadAttendeesRequest,
  stopEventRequest,
} from "../api/eventVendor";

export const handleVendorAction = async (action, eventId) => {
  if (!action || !eventId) return;

  message.destroy(); // Clear any existing messages before showing a new one

  switch (action) {
    case "download_attendees":
      await handleDownloadAttendees(eventId);
      break;
    case "stop_event":
      await handleStopEvent(eventId);
      break;

    default:
      message.warning("Unknown action.");
  }
};

// Sub-handlers

const handleDownloadAttendees = async (eventId) => {
  try {
    message.loading("Downloading attendees... Please wait.");
    const response = await downloadAttendeesRequest(eventId, "csv");

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `attendees-${eventId}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    message.destroy();
    message.success("Attendees downloaded successfully.");
  } catch (err) {
    message.destroy();
    message.error(err?.message || "Failed to download attendees.");
  }
};

const handleStopEvent = async (eventId) => {
  try {
    message.loading("Stopping event... Please wait.");
    const response = await stopEventRequest(eventId);
    message.destroy();
    message.success(response?.message || "Event stopped successfully.");
  } catch (err) {
    message.destroy();
    message.error(err?.message || "Failed to stop event.");
  }
};


